import React from "react"
import Typography from "aldoo-ra/Typography"
import DropDownSelect from "aldoo-ra/DropdownSelect"
import GridSummary from "aldoo-ra/GridSummary"
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

const PackSelectionStep = ({
  formData,
  errors,
  onInputChange,
  packs = [],
  selectedPack,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <Typography 
          component="h2"
          variant="admin_h4" 
          className="mb-4"
        >
          Select a License Pack
        </Typography>

        <Typography
          variant="admin_txt1"
          className="text-admin_text_secondary"
        >
          Choose the pack where the generated licenses will be organized
        </Typography>
      </div>

      {/* Show warning if no packs available */}
      {packs.length === 0 && (
        <div className="bg-admin_warning/10 border border-admin_warning/20 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <ExclamationTriangleIcon className="w-6 h-6 text-admin_warning" />
            <div>
              <Typography
                variant="admin_body"
                className="text-admin_warning font-medium"
              >
                No active license packs available
              </Typography>

              <Typography variant="admin_txt1_dim">
                Please create and activate a license pack first before
                generating licenses.
              </Typography>
            </div>
          </div>
        </div>
      )}

      <div>
        <Typography
          variant="admin_label"
          className="mb-1"
        >
          License Pack *
        </Typography>

        <DropDownSelect
          variant="admin"
          options={[
            {
              value: "",
              label:
                packs.length === 0
                  ? "No active packs available"
                  : "Select a pack...",
            },
            ...packs.map((pack) => ({
              value: pack._id,
              label: pack.name,
              description: pack.description || "No description",
            })),
          ]}
          value={
            formData.packId
              ? [
                  {
                    value: formData.packId,
                    label: selectedPack?.name || "",
                  },
                ]
              : []
          }
          onChange={(values) =>
            onInputChange("packId", values?.[0]?.value || "")
          }
          className="w-full"
          error={errors.packId}
          searchEnabled
          showCheckbox={false}
          disabled={packs.length === 0}
        />
        
        {errors.packId && (
          <Typography 
            variant="admin_txt2" 
            className="block text-admin_error mt-1"
          >
            {errors.packId}
          </Typography>
        )}

        {selectedPack && (
          <div className="mt-4">
            <GridSummary
              variant="admin"
              config={{
                layout: [
                  {
                    cells: [
                      {
                        type: "text",
                        label: "",
                        value: selectedPack.name,
                        valueColor: "text-admin_text font-medium",
                        colSpan: 2,
                      },
                    ],
                  },
                  {
                    cells: [
                      {
                        type: "statMedium",
                        label: "Current Licenses",
                        value: selectedPack.statistics?.licenses || 0,
                        colSpan: 1,
                        colStart: 1,
                      },
                      {
                        type: "statMedium",
                        label: "Current Seats",
                        value: selectedPack.statistics?.seats || 0,
                        colSpan: 1,
                        colStart: 2,
                      },
                    ],
                  },
                ],
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PackSelectionStep
